import React from 'react'
import { APP_NAME } from 'configs/AppConfig';
import IntlMessage from 'components/util-components/IntlMessage';
import {FacebookFilled} from '@ant-design/icons'
let dataEscuela =  JSON.parse(localStorage.getItem('dataEscuela')); 

export default function Footer() {
	return (
		<footer className="footer">
			<span>
				<span>
					<a style={{fontSize:'18px', color:'black', paddingRigth:10}}  href="https://www.facebook.com/facturasiempre" target='_blank'><FacebookFilled /></a>
				</span>
				Copyright  &copy;  {`${new Date().getFullYear()}`} <span className="font-weight-semibold">{`${APP_NAME}`}</span> <IntlMessage id='general.copyright' /> </span>
			<span>
			
			</span>
			<div>
				<span className="mx-2 text-muted"> PAC RFC: <a target='_blank' href="http://omawww.sat.gob.mx/tramitesyservicios/Paginas/pac_quadrum.htm">CVD110412TF6</a>  </span>
				<a target='_blank'  className="text-gray" href={'https://legal.dicodix.com/facturasiempre/legal_terms.html'} ><IntlMessage id='general.legalTerms' /></a>
				<span className="mx-2 text-muted"> | </span>
				<a target='_blank'  className="text-gray" href={'https://legal.dicodix.com/facturasiempre/legal_ap.html'}  ><IntlMessage id='general.legalPrivacy' /></a>
			</div>
		</footer>
	)
}

